import styled from "styled-components";
import MaterialInput from "../../../helperComponents/MaterialInput";
import CustomButton from "../../../helperComponents/CustomButton";
import { MdDelete } from "react-icons/md";
import { PiPlus } from "react-icons/pi";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  /* background: var(--surface3); */
  /* border: 1px solid var(--borderDim); */
  /* padding: 10px; */
  border-radius: 10px;
  gap: 20px;
  width: 100%;
  /* padding: 10px 15px; */
`;

const TopPart = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Label = styled.div`
  font-size: 17px;
  /* opacity: 0.5; */
  color: var(--elementDim);
  text-transform: capitalize;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  position: relative;
`;

const SubRow = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 80px);
  gap: 15px;
`;

export default function ContactsOfSiteInput({ value, onChange, label }) {
  if (!value) value = [{ clientName: "", phoneNumber: null, designation: "" }];

  return (
    <Container>
      <TopPart>
        <Label>{label}</Label>

        <CustomButton
          style={{ height: "30px" }}
          onClick={addContact}
          icon={<PiPlus />}
        >
          {/* Add Another Contact */}
        </CustomButton>
      </TopPart>

      <List>
        {value.map((item, index) => {
          return (
            <Row>
              <SubRow>
                <MaterialInput
                  label="Nom du contact"
                  value={item.clientName}
                  onChange={updateValue({ field: "clientName", index })}
                />
                <MaterialInput
                  label="Fonction"
                  value={item.designation}
                  onChange={updateValue({ field: "designation", index })}
                />
                <MaterialInput
                  type="number"
                  label="Numéro de téléphone"
                  value={item.phoneNumber}
                  onChange={updateValue({ field: "phoneNumber", index })}
                />
              </SubRow>
              <CustomButton
                style={{
                  width: "50px",
                  height: "55px",
                  flex: 1,
                  borderRadius: "10px",
                }}
                onClick={removeRow(index)}
                icon={<MdDelete />}
              ></CustomButton>
            </Row>
          );
        })}
      </List>
    </Container>
  );

  function removeRow(index) {
    return () => {
      if (value.length < 1) return null;

      let newValue = [...value];

      newValue.splice(index, 1);

      onChange(newValue);
    };
  }

  function addContact() {
    let newValue = [...value];

    newValue.push({ clientName: "", phoneNumber: null });

    onChange(newValue);
  }

  function updateValue({ field, index }) {
    return (e) => {
      let newValue = [...value];

      console.log("newValue", newValue);
      newValue[index][field] = e.target.value;
      console.log("newValue2", newValue);

      onChange(newValue);
    };
  }
}
